import React from "react";
import { useState } from "react";
import * as Icons from "../../assets/icons";
import * as Images from "../../assets/images";


const Navbar = () => {
  const routes = [
    {
      path: "/",
      name: "Home",
      sectionName: "/"
    },
    {
      path: "/#aboutSection",
      name: "About",
      sectionName: "#aboutsection"
    },
    {
      path: "/products",
      name: "Products",
      sectionName: "#productssection",
    },
    {
      path: "/pages",
      name: "Sectors",
      sectionName: "#sectorsection",
    },
    {
      path: "/blog",
      name: "Blog",
      sectionName: "#blogsection",
    },
    {
      path: "/contact",
      name: "Contact Us",
      sectionName: "#contactsection",
    },
  ];
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <>
      <div className=" container  text-sm lg:flex justify-between py-3 hidden ">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <Icons.Phone className="h-7 w-7" />
            <span>+971561273920 | 0565841949</span>
          </div>
          <div className="flex items-center gap-2">
            <Icons.Mail className="h-7 w-7" />
            <span>aamirarab888@gmail.com</span>
          </div>
          <div className="flex items-center gap-2">
            <Icons.Address className="h-7 w-7" />
            <span>Sharjah Media City, Sharjah, UAE</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com">
            <Icons.Facebook className="h-7 w-7" />
          </a>
          <a href="https://www.twitter.com">
            <Icons.Twitter className="h-7 w-7" />
          </a>
          <a href="https://www.instagram.com">
            <Icons.Instagram className="h-7 w-7" />
          </a>
          <a href="https://www.youtube.com">
            <Icons.Youtube className="h-7 w-7" />
          </a>
        </div>
      </div>
      <div className=" bg-primary ">
        <div className=" container py-6 lg:py-4  flex justify-between  items-center">
          <div>
            <img src={Images.GabeLogo} className="h-16 " alt="logo" />
          </div>
          <div className="text-white text-lg font-semibold gap-10 lg:flex hidden items-center">
            {routes.map((route) => (
              <span key={route.name}>
                <a href={`${route.sectionName}`}>{route.name}</a>
              </span>
            ))}
          </div>
          <div className="flex lg:hidden items-center">
            <button
              className="bg-white text-primary px-4 py-2 rounded-lg"
              onClick={handleMenuToggle}
            >
              {isMenuOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 11l7-7 7 7M5 19l7-7 7 7"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="bg-primary px-4">
          <div className="flex flex-col items-start justify-left h-full">
          {routes.map((route) => (
              <span key={route.name}>
                <a href={`${route.sectionName}`} className="block text-white text-lg font-semibold py-2">{route.name}</a>
              </span>
            ))}
          </div>
          
        </div>
      )}
    </>
  );
};

export default Navbar;
